import * as React from 'react'

const MapPin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Map Pin'
    fill='none'
    height='16'
    role='img'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Map Pin</title>
    <path d='M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0' />
    <circle cx='12' cy='10' r='3' />
  </svg>
)

export default MapPin



// WEBPACK FOOTER //
// ./src/components/icons/ui/MapPin.tsx